var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "redo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "redo_2",
    d: "M8.76367 7.36465L8.64746 6.03639L10.2305 5.89789C9.63112 5.32019 8.81587 4.96491 7.91764 4.96491C6.07669 4.96491 4.58431 6.4573 4.58431 8.29825C4.58431 10.1392 6.07669 11.6316 7.91764 11.6316C9.13149 11.6316 10.1938 10.9828 10.7767 10.013L12.1118 10.3468C11.3531 11.8972 9.76007 12.9649 7.91764 12.9649C5.34031 12.9649 3.25098 10.8756 3.25098 8.29825C3.25098 5.72092 5.34031 3.63158 7.91764 3.63158C9.21527 3.63158 10.3892 4.16121 11.2351 5.01608L11.0716 3.14746L12.3998 3.03125L12.7485 7.01603L8.76367 7.36465Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.bfe09b6535222c85ad16d84431de9ce2.svg";
export { ForwardRef as ReactComponent };